import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';
import { observer } from 'mobx-react-lite';
import styles from './index.module.scss';
import clsx from 'clsx';

interface DiscountCouponBottomSheetProps {}

const DiscountCouponBottomSheet: FC<DiscountCouponBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <NolNoticeBottomSheet
      /*특별혜택 자세히보기*/
      title={'NOL 할인쿠폰 자세히 보기'}
      isOpen={store.isDiscountCouponBottomSheetOpen}
      onRequestClose={() => (store.isDiscountCouponBottomSheetOpen = false)}
    >
      <strong>※ 이벤트 기간: {store.eventNolCouponPeriod}</strong>
      <br />
      <br />
      <div className={styles.subtitle}>[NOL 웰컴 쿠폰 혜택]</div>
      <div className={clsx(styles.grid, styles.grid5)}>
        <div className={styles.tableTitle}>사용처</div>
        <div className={styles.tableTitle}>혜택</div>
        <div className={styles.tableTitle}>수량</div>
        <div className={styles.tableTitle}>이용조건</div>
        <div className={styles.tableTitle}>비고</div>
        <div style={{ gridColumn: '1', gridRow: '2/7' }}>NOL 앱/웹</div>
        <div>국내숙소 50% 할인 쿠폰</div>
        <div>2장</div>
        <div>
          - 최대 할인 금액 5만원
          <br />- 5만원 이상 결제 시 사용 가능
        </div>
        <div style={{ gridColumn: '5', gridRow: '2/7' }}>
          <strong>특정 상품 이용 불가.</strong> 동일 상품에 대해 본 할인 쿠폰 외 다른 할인 쿠폰은 중복 적용 불가.
        </div>
        <div>해외숙소 50% 할인 쿠폰</div>
        <div>1장</div>
        <div>
          - 최대 할인 금액 5만원
          <br />- 5만원 이상 결제 시 사용 가능
        </div>
        <div>레저 50% 할인 쿠폰</div>
        <div>1장</div>
        <div>- 최대 할인 금액 5천원</div>
        <div>고속버스 50% 할인 쿠폰</div>
        <div>1장</div>
        <div>- 최대 할인 금액 5천원</div>
      </div>
      <div className={styles.separator} />
      <div className={styles.subtitle}>[NOL 실적 쿠폰 혜택]</div>
      <div className={clsx(styles.grid, styles.grid5)}>
        <div className={styles.tableTitle}>사용처</div>
        <div className={styles.tableTitle}>혜택</div>
        <div className={styles.tableTitle}>수량</div>
        <div className={styles.tableTitle}>이용조건</div>
        <div className={styles.tableTitle}>비고</div>
        <div style={{ gridColumn: '1', gridRow: '2/7' }}>NOL 앱/웹</div>
        <div>국내숙소 10% 할인쿠폰</div>
        <div>1장</div>
        <div>
          - 최대 할인 금액 3만원
          <br />- 10만원 이상 결제 시 사용 가능
        </div>
        <div style={{ gridColumn: '5', gridRow: '2/7' }}>
          <strong>특정 상품 이용 불가.</strong> 동일 상품에 대해 본 10% 할인 쿠폰 외 다른 할인 쿠폰은 중복 적용 불가.
        </div>
        <div>해외숙소 10% 할인쿠폰</div>
        <div>1장</div>
        <div>
          - 최대 할인 금액 1.5만원 <br />- 10만원 이상 결제 시 사용 가능
        </div>
        <div>렌터카 10% 할인 쿠폰</div>
        <div>1장</div>
        <div>- 최대 할인 금액 5천원</div>
        <div>고속버스 10% 할인쿠폰</div>
        <div>1장</div>
        <div>- 최대 할인 금액 5천원</div>
        <div>레저 10% 할인 쿠폰</div>
        <div>1장</div>
        <div>- 최대 할인 금액 5천원</div>
      </div>
      [NOL 쿠폰 종류 및 발행조건]
      <div className={clsx(styles.grid, styles.grid52)}>
        <div className={styles.tableTitle}>쿠폰명</div>
        <div className={styles.tableTitle}>발행 조건</div>
        <div className={styles.tableTitle}>발행 주기</div>
        <div className={styles.tableTitle}>발행 시점</div>
        <div className={styles.tableTitle}>사용 기간</div>
        <div>NOL 웰컴 쿠폰</div>
        <div>
          - NOL 카드 페이에 NOL 카드 최초 등록 후 30일 이내 NOL 회원으로 가입 시 쿠폰 자동 발행
          <br />- NOL 카드 교체 · 해지 및 재발급하여 재등록 시 이벤트 대상에서 제외
        </div>
        <div>최초 1회</div>
        <div>조건 부합시 쿠폰함에 자동 지급</div>
        <div>쿠폰 발급일로부터 30일</div>
        <div>NOL 실적 쿠폰</div>
        <div>- NOL 카드 전월 이용 실적 40만원 이상 달성 고객</div>
        <div>매월 1회</div>
        <div>당월 6일 순차 발급</div>
        <div>당월 6일 ~ 익월 5일</div>
      </div>
      <strong>[NOL 카드 쿠폰 유의사항]</strong>
      <ul className={styles.descriptions}>
        <li>
          <strong>
            NOL 카드 웰컴쿠폰은 NOL 카드 페이에 NOL 카드 최초 등록 후 30일 이내 NOL 회원으로 가입 시 제공됩니다.
            <br />
            (단,NOL 카드 본인 회원에 한해 1회 혜택 제공 / NOL 카드 교체ᆞ해지 및 재발급 하여 재등록시 이벤트 대상에서
            제외)
          </strong>
        </li>
        <li>
          <strong>NOL 카드 실적쿠폰은 NOL 카드 전월 이용 실적 40만원 이상 달성 시 제공됩니다.</strong>
        </li>
        <li>
          <strong>조건 충족 시, NOL 플랫폼에 가입된 본인 회원 계정의 쿠폰함으로 자동 제공</strong>되며, NOL 실적 쿠폰은
          당월 6일 영업 시간 내 순차적으로 발급됩니다. 예시) NOL 회원은 NOL 앱/웹 쿠폰함에서 확인 가능
        </li>
        <li>
          할인 쿠폰의 할인비율과 최소 결제 금액 조건은 상품 판매가(포인트 미적용 금액)를 기준으로 하며, NOL 카드페이에
          등록된 NOL 카드로 NOL 앱/웹에서 결제 시에만 NOL 쿠폰 사용 가능
        </li>
        <li>
          <u>
            이벤트 혜택(포인트, 캐시백, 쿠폰 등)을 제공받은 달부터 13개월 내 대상 카드 해지 또는 탈회 시 받은 혜택은
            현금으로 청구되거나, 등록된 본인 명의 결제 계좌에서 자동 출금될 수 있음
            <br />
            (예시 : 2026년 3월에 혜택을 제공받은 후, 2027년 3월 31일 이전에 대상 카드 해지 또는 탈회 시 제공받은 혜택
            금액만큼 청구)
          </u>
        </li>
        <li>
          혜택 제공월 포함 12개월 내 이벤트 채널에 관계없이 현대카드의 다른 이벤트 혜택(캐시백, 포인트, 할인 쿠폰 등)을
          받은 이력이 있는 경우, 조건을 충족하더라도 혜택 제외
        </li>
        <li>본 이벤트는 당사 또는 제휴사 사정에 의해 변경 또는 중단될 수 있습니다.</li>
        <li>상세 내용은 페이지 하단의 유의사항 참조</li>
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(DiscountCouponBottomSheet);
